import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    status: 'index',
    giftName: '十二星座之狮子座',
    giftImgUrl: 'http://image.gujin8.com/weImage/2019/10/11/3504689f0728474a3f254e4977808dae-bbs.png',
    urlData: {
      url: process.env.NODE_ENV === 'development' ? '/api/weappservice/was' : '/weappservice/was',
      // url: '192.168.2.121:81/weappservice/was',
      // sessionid: '',
      token: '',
      fm: 'json',
      appKey: 'we_h5_1.0',
      v: '1.0',
      source: 'venus'
    },
    androidShareImgUrl: 'http://apps.tiduhn.cn/image/share_call_friend4.png',
    shareTitle: '我邀请你一起来恋爱物语发现有趣的灵魂',
    shareDesc: '我和你除了谈恋爱没什么好谈的，谈恋爱，我在恋爱物语等你',
    shareUrl: 'http://api.cdadkj.com:84/activity/inviteRecall/share',
    downloadUrl: 'http://www.tiduhn.cn/',
    limitTime: '2050-12-26 23:59:59',
    userInfo: null
  },
  mutations: {
    setLoginAccount(state, userInfo) {
      state.userInfo = userInfo
    },
    setSessionId(state, sessionId) {
      // state.urlData.sessionid = sessionId
      state.urlData.token = sessionId
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js